import { render, staticRenderFns } from "./CasAssociation.vue?vue&type=template&id=2c7e2456&scoped=true&"
import script from "./CasAssociation.vue?vue&type=script&lang=ts&"
export * from "./CasAssociation.vue?vue&type=script&lang=ts&"
import style0 from "./CasAssociation.vue?vue&type=style&index=0&id=2c7e2456&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7e2456",
  null
  
)

export default component.exports